import { 
	HIGHLIGHT_GEOJSON_COUNTRY_LAYER,
	SHOW_COUNTRY_NAME_TOOLTIP
} from '../constants/map-action-types';

export const highlightGeoJsonCountryLayer = (payload) => (
	{ type: HIGHLIGHT_GEOJSON_COUNTRY_LAYER, payload}
	);

export const showCountryNameTooltip = (payload) => (
	{ type: SHOW_COUNTRY_NAME_TOOLTIP, payload});